export default __webpack_public_path__ + "static/media/contact.79d97dfe.png";